/* Hilfen der Seite „Eigenschaften“: welche Entity zur Auswahl gehört, Größenfelder prüfen, Spawnflags. Reine Funktionen ohne DOM. */
import type { BBox, Brush, Doc, Entity, Sel } from './types.ts';
import Cmd from './cmds.ts';

/** Die Entity, deren Eigenschaften bearbeitet werden: eine einzelne gewählte Punkt-Entity, oder die Brush-Entity,
 *  zu der alle gewählten Brushes gehören (nicht die Welt). Sonst null. */
export function selectionEntity(doc: Doc, sel: Sel): Entity | null {
  const bs = Cmd.selBrushes(doc, sel), es = Cmd.selEnts(doc, sel);
  if (es.length === 1 && !bs.length) return es[0];
  if (!bs.length) return null;
  const owners = new Set<number>();
  doc.ents.forEach((e, i) => { if (e.brushes.some((b) => sel.b.has(b.id))) owners.add(i); });
  if (owners.size !== 1) return null;
  const i = Array.from(owners)[0];
  return i > 0 ? doc.ents[i] : null;
}

/** Neue Auswahlbox aus den sechs Eingabefeldern; null bei ungültigen Zahlen oder einer Seite kürzer als 1 Einheit */
export function bboxFromInputs(min: number[], max: number[]): BBox | null {
  const all = min.concat(max);
  if (min.length !== 3 || max.length !== 3 || all.some((x) => !isFinite(x))) return null;
  if ([0, 1, 2].some((i) => max[i] - min[i] < 1)) return null;
  return { min: [min[0], min[1], min[2]], max: [max[0], max[1], max[2]] };
}

/** Größe der Box je Achse, auf zwei Stellen gerundet */
export const sizeOf = (bb: BBox): number[] => [0, 1, 2].map((i) => Math.round((bb.max[i] - bb.min[i]) * 100) / 100);

/** Spawnflags: Bit setzen oder löschen */
export const toggleFlag = (cur: number, bit: number, on: boolean): number => (on ? cur | bit : cur & ~bit);

/** Bits, die die Beschreibung nicht kennt (z. B. aus einer anderen Mod) */
export function unknownFlagBits(cur: number, flags: readonly (readonly [number, ...unknown[]])[]): number {
  let known = 0; flags.forEach((f) => { known |= f[0]; });
  return cur & ~known;
}

/** Texturnamen der Brushes (ohne Doppelte, in Reihenfolge des Auftretens) */
export function usedTexNames(bs: Brush[]): string[] {
  const names = new Set<string>();
  bs.forEach((b) => b.faces.forEach((f) => names.add(f.tex)));
  return Array.from(names);
}
